import axios from "axios";
import api from "./api";

const apiUrl = process.env.REACT_APP_API_URL;
export const cdnUrl = process.env.REACT_APP_CDN_URL;

const anonApi = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
  }
});

export const sendFile = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  const resp = await api.post(`${cdnUrl}/upload-not-save`, formData);

  return resp.data;
}

export const postAnon = async (method: string, data = {}) => {
  const resp = await anonApi.post(method, data);
  return resp.data;
};

export const getAnon = async (method: string, params = {}) => {
  const resp = await anonApi.get(method, { params });
  return resp.data;
};

export const postUser = async (method: string, data = {}) => {
  const resp = await api.post(method, data);
  return resp.data;
};

export const getUser = async (method: string, params = {}) => {
  const resp = await api.get(method, { params });
  return resp.data;
};

export const deleteUser = async (method: string, data = {}) => {
  const resp = await api.delete(method, { data });
  return resp.data;
};
